import * as types from './actionTypes';
import { apiRequest, apiPost } from '../utils/request';
import { toastr } from 'react-redux-toastr';

// Truck receipts scoped to a run. The picker modal uses the unassigned subset; the bottom-of-run
// list uses the whole set. Backfilling context (run/pickup/tank) onto a receipt happens cloud-side,
// keyed on the receipt's stable id — see RunsController.AssignReceipt.

export function runReceiptsLoading(runId) {
    return { type: types.RUN_RECEIPTS_LOADING, runId };
}

export function runReceiptsLoaded(runId, items) {
    return { type: types.RUN_RECEIPTS_LOADED, runId, items };
}

export function loadRunReceipts(runId) {
    return function (dispatch) {
        if (!runId) {
            return Promise.resolve();
        }
        dispatch(runReceiptsLoading(runId));
        return apiRequest(`/api/runs/${runId}/receipts`)
            .then(x => {
                if (x.error) {
                    console.log('Failed to load run receipts', x.error);
                    dispatch(runReceiptsLoaded(runId, []));
                } else {
                    dispatch(runReceiptsLoaded(runId, Array.isArray(x.data) ? x.data : []));
                }
            });
    };
}

export function assignReceipt(runId, receiptId, pickupId, tankId) {
    return function (dispatch) {
        return apiPost('/api/runs/receipts/assign', {
            receiptId,
            runId,
            pickupId,
            tankId,
            unassign: false,
        }).then(x => {
            if (x.error || (x.data && x.data.assigned === false)) {
                toastr.warning('That receipt could not be assigned — it may already be in use. Refreshing the list.');
            }
            // Refresh so both the picker and the bottom list reflect the new association.
            return dispatch(loadRunReceipts(runId));
        });
    };
}

// Collection receipts are assigned many-at-once (a tank's total is the sum of every receipt the
// driver selects for it), so this fires one assign POST per id in parallel and refreshes the run's
// receipt list only once at the end, rather than dispatching assignReceipt per id (which would
// refresh N times).
export function assignReceipts(runId, receiptIds, pickupId, tankId) {
    return function (dispatch) {
        const ids = Array.isArray(receiptIds) ? receiptIds : [];
        if (ids.length === 0) {
            return Promise.resolve();
        }
        return Promise.all(ids.map(receiptId => apiPost('/api/runs/receipts/assign', {
            receiptId,
            runId,
            pickupId,
            tankId,
            unassign: false,
        }))).then(results => {
            if (results.some(x => x.error || (x.data && x.data.assigned === false))) {
                toastr.warning('Some receipts could not be assigned — they may already be in use. Refreshing the list.');
            }
            return dispatch(loadRunReceipts(runId));
        });
    };
}

export function unassignReceipt(runId, receiptId) {
    return function (dispatch) {
        return apiPost('/api/runs/receipts/assign', {
            receiptId,
            runId,
            pickupId: null,
            tankId: null,
            unassign: true,
        }).then(() => dispatch(loadRunReceipts(runId)));
    };
}
